
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitomahabaleshwarcab() {



const cardData = {
  keyword: 'Navi Mumbai to Mahabaleshwar Cab',
  heading: 'Skyline Cabs: Navi Mumbai to Mahabaleshwar Cab',
  headingDescription: 'Skyline Cabs offers safe, comfortable, and affordable Navi Mumbai to Mahabaleshwar Cab services for smooth hill-station travel. Whether you are planning a weekend getaway, family vacation, honeymoon trip, or corporate retreat, we provide punctual pickup and professional long-distance travel experience. Our fleet includes AC sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles ideal for ghat roads and mountain routes. With transparent pricing, one way and round trip options, and secure online cab booking Navi Mumbai to Mahabaleshwar, Skyline Cabs ensures relaxed and scenic travel to Mahabaleshwar.',

  top: 'Top Places to Visit in Mahabaleshwar with Skyline Cabs',

  topPlaces: [
    {
      title: "Venna Lake",
      description: "Venna Lake is one of the most popular attractions in Mahabaleshwar offering boating activities and scenic views. Surrounded by hills and greenery, it is ideal for families and couples. Horse riding and lakeside snacks enhance the experience."
    },
    {
      title: "Arthur’s Seat",
      description: "Arthur’s Seat offers breathtaking valley views and is known as the ‘Queen of Points’ in Mahabaleshwar. It provides panoramic mountain scenery."
    },
    {
      title: "Mapro Garden",
      description: "Mapro Garden is famous for strawberry products, chocolate factory visits, and relaxing garden atmosphere."
    },
    {
      title: "Elephant’s Head Point",
      description: "Elephant’s Head Point offers dramatic cliff views resembling an elephant’s head and is popular for photography."
    },
    {
      title: "Wilson Point",
      description: "Wilson Point is the highest point in Mahabaleshwar and perfect for sunrise views."
    },
    {
      title: "Lingmala Waterfall",
      description: "Lingmala Waterfall is a scenic waterfall surrounded by lush greenery and mist during monsoon."
    },
    {
      title: "Pratapgad Fort",
      description: "Pratapgad Fort is a historic Maratha fort offering stunning valley views and rich heritage."
    },
    {
      title: "Panchganga Temple",
      description: "Panchganga Temple is a religious site believed to be the origin of five rivers."
    },
    {
      title: "Mahabaleshwar Temple",
      description: "Mahabaleshwar Temple is an ancient Shiva temple attracting devotees year-round."
    },
    {
      title: "Kate’s Point",
      description: "Kate’s Point provides panoramic views of Dhom Dam and surrounding hills."
    }
  ],

  services: [
    {
      name: "Complete Navi Mumbai to Mahabaleshwar Cab Solutions",
      description: "Skyline Cabs provides mumbai to mahabaleshwar cab, mumbai to mahabaleshwar taxi fare, mumbai to mahabaleshwar taxi, car from mumbai to mahabaleshwar, mumbai to mahabaleshwar cab booking, mumbai to mahabaleshwar round trip cab, taxi for mahabaleshwar from mumbai, navi mumbai to mahabaleshwar cab, navi mumbai to mahabaleshwar cab, navi mumbai to mahabaleshwar cab, navi mumbai to mahabaleshwar taxi, navi mumbai to mahabaleshwar cab service, taxi from navi mumbai to mahabaleshwar, cab from navi mumbai to mahabaleshwar, book cab navi mumbai to mahabaleshwar, online cab booking navi mumbai to mahabaleshwar with professional chauffeurs and well-maintained AC vehicles ensuring safe and scenic ghat road travel experience."
    },
    {
      name: "One Way & Round Trip Mahabaleshwar Taxi Service",
      description: "Whether you require mumbai to mahabaleshwar cab booking or mumbai to mahabaleshwar round trip cab, Skyline Cabs ensures smooth travel with transparent mumbai to mahabaleshwar taxi fare and flexible return scheduling. Our navi mumbai to mahabaleshwar taxi service provides comfortable sedan, Ertiga, Innova, and SUV vehicles suitable for long-distance hill travel."
    },
    {
      name: "Online & Advance Cab Booking Navi Mumbai to Mahabaleshwar",
      description: "Customers can easily book cab navi mumbai to mahabaleshwar or use online cab booking navi mumbai to mahabaleshwar platform for instant confirmation. Whether choosing taxi from navi mumbai to mahabaleshwar or cab from navi mumbai to mahabaleshwar, Skyline Cabs guarantees secure booking and transparent pricing."
    },
    {
      name: "Premium & Budget Cab Options",
      description: "From car from mumbai to mahabaleshwar options to affordable navi mumbai to mahabaleshwar cab service, we provide multiple vehicle categories ensuring comfortable and safe journey for families, couples, and corporate groups."
    }
  ],

  tableData: [
    ["Mumbai to Mahabaleshwar Cab", "Mumbai to Mahabaleshwar Taxi Fare"],
    ["Mumbai to Mahabaleshwar Taxi", "Car from Mumbai to Mahabaleshwar"],
    ["Mumbai to Mahabaleshwar Cab Booking", "Mumbai to Mahabaleshwar Round Trip Cab"],
    ["Taxi for Mahabaleshwar from Mumbai", "Navi Mumbai to Mahabaleshwar Cab"],
    ["Navi Mumbai to Mahabaleshwar Taxi", "Navi Mumbai to Mahabaleshwar Cab Service"],
    ["Taxi from Navi Mumbai to Mahabaleshwar", "Cab from Navi Mumbai to Mahabaleshwar"],
    ["Book Cab Navi Mumbai to Mahabaleshwar", "Online Cab Booking Navi Mumbai to Mahabaleshwar"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Safe & Experienced Ghat Drivers",
      WhyChoosedescription: "Our drivers are highly experienced in mountain and ghat section driving ensuring smooth and safe Navi Mumbai to Mahabaleshwar cab travel even during monsoon season."
    },
    {
      WhyChooseheading: "Transparent Pricing & Fare Clarity",
      WhyChoosedescription: "We provide clear mumbai to mahabaleshwar taxi fare and navi mumbai to mahabaleshwar cab pricing without hidden charges ensuring budget-friendly travel."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription: "Choose from sedan, Ertiga, Innova, Innova Crysta, and SUV vehicles based on group size and comfort needs."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Our navi mumbai to mahabaleshwar taxi service operates round-the-clock for early morning and late-night departures."
    },
    {
      WhyChooseheading: "Online & Instant Booking",
      WhyChoosedescription: "Use online cab booking navi mumbai to mahabaleshwar for secure and instant confirmation."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Travel",
      WhyChoosedescription: "Enjoy smooth AC travel experience with clean vehicles and professional chauffeurs."
    },
    {
      WhyChooseheading: "Reliable & Punctual Service",
      WhyChoosedescription: "We ensure on-time pickup and drop with efficient route planning."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription: "Ideal for family trips, honeymoon travel, corporate outings, and weekend getaways."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How can I book a Navi Mumbai to Mahabaleshwar Cab with Skyline Cabs?',
        answer:
            'You can easily book your Navi Mumbai to Mahabaleshwar Cab through our website or mobile app. Enter Navi Mumbai as your pickup location, Mahabaleshwar as your drop destination, choose your preferred vehicle, and confirm your ride instantly.',
    },
    {
        id: 2,
        question: 'Is Navi Mumbai to Mahabaleshwar Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs operates 24/7 Navi Mumbai to Mahabaleshwar Cab service, allowing you to travel at your preferred time, including early morning or late-night departures.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Navi Mumbai to Mahabaleshwar Cab?',
        answer:
            'We offer Sedans, SUVs, Ertiga, Innova Crysta, and premium vehicles for your Navi Mumbai to Mahabaleshwar Cab journey — ideal for families, couples, and group travelers.',
    },
    {
        id: 4,
        question: 'Is the fare for Navi Mumbai to Mahabaleshwar Cab fixed?',
        answer:
            'Yes, Skyline Cabs provides transparent and fixed pricing. The fare includes tolls, taxes, and driver charges with no hidden costs.',
    },
    {
        id: 5,
        question: 'Can I book a one-way Navi Mumbai to Mahabaleshwar Cab?',
        answer:
            'Yes, we offer affordable one-way Navi Mumbai to Mahabaleshwar Cab service, allowing you to pay only for the distance traveled.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Navi Mumbai to Mahabaleshwar by cab?',
        answer:
            'The journey typically takes around 5 to 6 hours depending on traffic and road conditions, offering a comfortable and scenic drive to Mahabaleshwar.',
    },
    {
        id: 7,
        question: 'Are online payment options available for booking?',
        answer:
            'Yes, we support secure online payments via UPI, credit/debit cards, and net banking. Instant confirmation is provided after successful payment.',
    },
    {
        id: 8,
        question: 'Can I schedule my Navi Mumbai to Mahabaleshwar Cab in advance?',
        answer:
            'Absolutely. You can pre-book your cab in advance for weekends, holidays, or special trips to ensure guaranteed availability.',
    },
    {
        id: 9,
        question: 'Is Navi Mumbai to Mahabaleshwar Cab suitable for family trips?',
        answer:
            'Yes, our spacious and well-maintained vehicles make Navi Mumbai to Mahabaleshwar Cab service ideal for family vacations and group travel.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai to Mahabaleshwar Cab?',
        answer:
            'Skyline Cabs offers professional drivers, clean and sanitized vehicles, competitive pricing, punctual service, and 24x7 customer support — making your Navi Mumbai to Mahabaleshwar trip safe and enjoyable.',
    },
];

const someReviews = [
    {
        name: "Mr. Prakash Sawant",
        rating: 5,
        review: "Booked a Navi Mumbai to Mahabaleshwar Cab with Skyline Cabs for a weekend trip. The journey was smooth and comfortable, and the driver was very professional. Great experience!"
    },
    {
        name: "Mrs. Shalini Deshpande",
        rating: 4,
        review: "Very reliable Navi Mumbai to Mahabaleshwar Cab service. Transparent pricing and clean vehicle made our family trip stress-free. Highly recommended!"
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Mahabaleshwar Cab",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-mahabaleshwar-cab.jpg",
  "description": "Book Navi Mumbai to Mahabaleshwar Cab with Skyline Cabs for safe and comfortable hill station travel. One way and round trip taxi service available with sedan, SUV and Innova Crysta at affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-to-mahabaleshwar-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Navi Mumbai to Mahabaleshwar Cab | One Way & Round Trip Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Mahabaleshwar Cab with Skyline Cabs for reliable one way and round trip taxi service. Affordable fares, professional drivers and comfortable cars available 24x7." 
  />
  <meta 
    name="keywords" 
    content="mumbai to mahabaleshwar cab, mumbai to mahabaleshwar taxi fare, mumbai to mahabaleshwar taxi, car from mumbai to mahabaleshwar, mumbai to mahabaleshwar cab booking, mumbai to mahabaleshwar round trip cab, taxi for mahabaleshwar from mumbai, navi mumbai to mahabaleshwar cab, navi mumbai to mahabaleshwar taxi, navi mumbai to mahabaleshwar cab service, taxi from navi mumbai to mahabaleshwar, cab from navi mumbai to mahabaleshwar, book cab navi mumbai to mahabaleshwar, online cab booking navi mumbai to mahabaleshwar, best cab navi mumbai to mahabaleshwar, cheapest cab navi mumbai to mahabaleshwar, reliable taxi navi mumbai to mahabaleshwar, one way cab navi mumbai to mahabaleshwar, Skyline Cabs Navi Mumbai to Mahabaleshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/122.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitomahabaleshwarcab;